export default __webpack_public_path__ + "static/media/mfp-with-bg.0eaa4dd3.png";